import { Link } from "react-router-dom";

// "THIS MUSIC SAVES LIVES" — SVG text stretched to exactly fit the footer width, always centered.
export const SavesLivesTagline = ({ to = "/passport", className = "", testId = "player-tagline" }) => (
  <Link to={to} className={`block w-full bg-white hover:bg-[#f4fdff] px-3 py-1.5 ${className}`} aria-label="This music saves lives — open the HOARD" data-testid={testId}>
    <svg viewBox="0 0 420 36" className="block w-full max-w-[560px] mx-auto h-auto" role="img" aria-hidden="true">
      <text x="210" y="30" textAnchor="middle" textLength="404" lengthAdjust="spacingAndGlyphs" fontSize="34" fontWeight="800" fill="#54E3FF" fontFamily="inherit" letterSpacing="1">THIS MUSIC SAVES LIVES</text>
    </svg>
  </Link>
);

// Shown to visitors without an account: one tap → anonymous account (no email), the key to the whole HOARD.
export const AnonymousAccountCTA = ({ compact = false, testId = "player-anon-cta" }) => (
  <Link
    to="/auth?view=anonymous&tab=create"
    className={`group flex items-center gap-3 rounded-xl border border-[#54E3FF]/50 bg-[#54E3FF]/10 hover:bg-[#54E3FF]/20 transition-colors ${compact ? "px-3 py-2" : "px-4 py-3"}`}
    data-testid={testId}
  >
    <span className="h-8 w-8 rounded-full bg-[#54E3FF] text-[#120A24] font-black flex items-center justify-center shrink-0 text-sm">1</span>
    <span className="min-w-0 leading-snug">
      <span className={`block font-extrabold text-white ${compact ? "text-sm" : "text-base"}`}>One tap. No email. Full tracks.</span>
      <span className="block text-xs text-white/75">Make an <strong className="text-[#54E3FF]">anonymous account</strong> — we hand you a private number, nothing else. Then unlock the whole WALL HOARD.</span>
    </span>
    <span className="ml-auto text-[#54E3FF] font-bold text-sm whitespace-nowrap group-hover:translate-x-0.5 transition-transform">Go →</span>
  </Link>
);
